import BaseComponent from 'scripts/BaseComponent.js';

export default class LandingThreeCardModuleCard extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      link: '.js-link',
    };

    this.dom = {
      $component: component,
      $link: this.$get(this.refs.link),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();
    this.setClick(dom.$component, this.handleClick);
  }

  handleClick() {
    const { dom } = this;
    window.location = dom.$link.href;
  }
}
